module.exports = __webpack_public_path__ + "img/Dreamtown.5ec76b5b.png";